var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`iq-colorbox color-fix ` + _vm.miniClass},[(_vm.hasIconSlot)?_vm._t("icon"):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }